module.exports = __webpack_public_path__ + "img/download.ce223d84.png";